import api from "@/lib/axiosConfig";
import { BASE } from "@/api/cms-puck/client";

/* -------------------------------------------------------------------------- */
/* Aiguillage CMS avancé (par instance)                                       */
/* -------------------------------------------------------------------------- */

export async function getCmsAdvanced(): Promise<{ advancedCmsEnabled: boolean }> {
  const { data } = await api.get<{ advancedCmsEnabled: boolean }>(
    `${BASE}/advanced`,
  );
  return data;
}

export async function setCmsAdvanced(
  enabled: boolean,
): Promise<{ advancedCmsEnabled: boolean }> {
  const { data } = await api.put<{ advancedCmsEnabled: boolean }>(
    `${BASE}/advanced`,
    { enabled },
  );
  return data;
}
